import React from 'react'
import img1 from '../../assets/rating-stars.png'
import img2 from '../../assets/hiring.png'
import img3 from '../../assets/infrastructure.png'
import img4 from '../../assets/salary.png'

const Uniquefea = () => {
  return (
    <div className='unique-fea-sec ws-section pb-lg-5'>
        <div class="container">
            <div class="row">
                <div class="col-lg-12 text-center pb-5">
                    <h1>Unique Features of Takshila VLSI</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3">
                    <div class="fea-box text-center">
                        <div class="fea-box-top mb-3">
                            <img src={img1} alt=''/>
                        </div>
                        <div class="wpb_wrapper">
                        <p><strong>Course delivered by Experts</strong></p>
                        <p>Experts in the industry teach our various courses to students. At Takshila, our experts share their experience and help build the career of our students in the VLSI industry. You have the opportunity of carrying out practical applications and examples.</p>

                        </div>
                    </div>

                </div>
                <div class="col-lg-3">
                    <div class="fea-box text-center">
                        <div class="fea-box-top mb-3">
                            <img src={img2} alt=''/>
                        </div>
                        <div class="wpb_wrapper">
                        <p><strong>100% placement support&nbsp;</strong></p>
                        <p><strong>&nbsp;</strong>Our main goal is to help engineers build a successful career in the VLSI industry. Not only we do train you, but we also coach you in order to become a best Chip Designer. Our training process allows students to learn even complex technologies within a short time space and transforming them into professionals in no time.</p>

                    </div>
                    </div>

                </div>
                <div class="col-lg-3">
                    <div class="fea-box text-center">
                        <div class="fea-box-top mb-3">
                            <img src={img3} alt=''/>
                        </div>
                        <div class="wpb_wrapper">
                        <p><strong>Superior Training infrastructure and Methodology</strong></p>
                        <p><strong>&nbsp;</strong>Industry experts carefully designed the training program based on the career growth and job opportunities available in the VLSI industry. We use an unique training methodology for our students with 70% of the course time allocated to the labs, mini-projects, and the final projects. However, the other 30% is allocated to imparting the technologies to our student.</p>

                    </div>
                    </div>

                </div>
                <div class="col-lg-3">
                    <div class="fea-box text-center">
                        <div class="fea-box-top mb-3">
                            <img src={img4} alt=''/>
                        </div>
                        <div class="wpb_wrapper">
                        <p><strong>Value for Money</strong></p>
                        <p>We teach you all advanced courses at a reasonable cost. We offer you more for less.</p>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
  )
}

export default Uniquefea